import React, { useContext } from "react";
import {
    // Avatar,
    Col,
    // Dropdown,
    // Menu,
    Row
} from "antd";
// import { DownOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Link }  from "react-router-dom";
import logo from "../../../assets/images/Logo-Tow-Pro-onDark-RGB.png";
import StateContext from "../../../shared/context/StateContext";
import { ACTIONS } from "../../../shared/context/Constants";

// Helpers
// import { clearUser } from "../helpers/user";
// import { clearToken } from "../helpers/auth";

// const menu = (
//     <Menu style={{ minWidth: 150 }}>
//         <Menu.Item>
//             <Link
//                 to="/login"
//                 onClick={() => {
//                     // clearUser();
//                     // clearToken();
//                 }}
//                 style={{ marginTop: 4, marginBottom: 4 }}
//             >
//                 <LogoutOutlined />
//                 <span style={{ paddingLeft: 8 }}>Logout</span>
//             </Link>
//         </Menu.Item>
//     </Menu>
// );

const TopNavigation = () => {
    const { state, dispatch } = useContext(StateContext);
    return (
        <Row>
            <Col span={4}>
                <div className="logo" style={{ maxHeight: 54 }}>
                    <Link to="/" onClick={() => dispatch({ type: ACTIONS.SET_STATE, state: null })}>
                        <img
                            src={logo}
                            alt="Main Logo"
                            style={{ maxHeight: 54 }}
                        />
                    </Link>
                </div>
            </Col>
            {
                state?.state === "UT" && 
                <Col span={18} style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        textAlign: "right",
                    }}>
                    <a style={{ color: 'white', fontSize: '20px' }} 
                    href="https://www.udot.utah.gov/connect/business/motor-carriers/tow-trucks/utah-bill-of-rights-regarding-towing/" 
                    target="_blank" rel="noreferrer" >
                        Know your rights
                    </a>
                </Col>
            }
            {
                state?.state === "WI" && 
                <Col span={18} style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        textAlign: "right",
                    }}>
                    <a style={{ color: 'white', fontSize: '20px' }} 
                    href="https://wisconsindot.gov/Pages/dmv/vehicles/title-plates/involuntary-lien-transfers.aspx?utm_source" 
                    target="_blank" rel="noreferrer" >
                        Know your rights
                    </a>
                </Col>
            }
            {
                state?.state === "ID" && 
                <Col span={18} style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        textAlign: "right",
                    }}>
                    <a style={{ color: 'white', fontSize: '20px' }} 
                    href="https://itd.idaho.gov/dmv/registrations-plates-titles/abandoned-vehicles/?utm_source" 
                    target="_blank" rel="noreferrer" >
                        Know your rights
                    </a>
                </Col>
            }
            {/* <Col
                span={20}
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    textAlign: "right",
                }}
            >
                <Dropdown overlay={menu}>
                    <div style={{ marginRight: 15 }}>
                        <div className="ant-dropdown-link">
                            <Avatar
                                icon={<UserOutlined />}
                                style={{
                                    backgroundColor: "#87d068",
                                    marginRight: 5,
                                }}
                            />
                            <span
                                style={{
                                    color: "#404040",
                                    cursor: "default",
                                    display: "inline-block",
                                    fontSize: 16,
                                    height: 64,
                                    lineHeight: "64px",
                                    marginLeft: 6,
                                    marginRight: 15,
                                }}
                            >
                                First Last
                            </span>
                            <DownOutlined />
                        </div>
                    </div>
                </Dropdown>
            </Col> */}
        </Row>
    );
};

export default TopNavigation;
